import {createDocumentResource, createQueryResource, list} from "retil";
import axios from "axios";
import {Entry} from "@2021-contest-web/components/src/types";
import {BaseURL, ContestToken, isMock} from "./config";

export const entry = createDocumentResource<Entry>('entry');
export const entryList = createQueryResource('entryList', {
    for: list(entry),
    load: async () => {
        if (isMock()) {
            return await mock();
        } else {
            return await fetch();
        }
    },
});

function validate(source: Entry[]): Entry[] {
    return source
        .filter((entry: Entry) => !!(entry.name?.trim()))
        .filter((entry: Entry) => entry.block === "A" || entry.block === "B" || entry.block === "C" || entry.block === "D") // NOTE:- Block A OR B OR C Only
        .map((entry: Entry) => {
            return { ...entry, id: entry.entry_id };
        });
}

async function mock(): Promise<Entry[]> {
    const {result} = await import('../cache/profiles/1.json');
    return validate(result as any);
}

async function fetch(): Promise<Entry[]> {
    try {
        const res = await axios.get(BaseURL!, {
            headers: {
                'content-type': 'application/json',
                'x-access-token': ContestToken
            },
        });
        return validate(res.data.result);
    } catch (error) {
        return [];
    }
}